"use client";
import React, { useEffect, useMemo, useState } from "react";
import "./page.css";
import Template4 from "../../../Components/Templates/Template4";
import Download from "../../../Components/Download/Download";
import Section from "../../../Components/Section/Section";
import { useParams } from "next/navigation";
import { _eventBus } from "../../../core/events/EventBus";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { mainAppStartupFlowExecute } from "../../../Flows/MainAppPage/MainAppStartFlow";
import { useRecState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICmsSpecialFareOfferResponse } from "../../../Orchestrator/Types/Interface/ICMSOffers";
import { useOnLanguageChange } from "../../../Components/CustomHooks/useOnLanguageChange";
import { useIntl } from "react-intl";
import { cmsImageUrl } from "../../../Lib/Utils/cmsImage";

const OfferDetailPage = () => {
  const intl = useIntl();
  // const [offerDetail] = useRecState<ICmsOffers>("cmsOfferDetailAtom");
  const [specialOfferDetail] = useRecState<ICmsSpecialFareOfferResponse>("cmsSpecialFareOfferDetailResponseAtom");
  const [initialLoadFinished, setInitialLoadFinished] = useState(false);
  const params = useParams();
  const slug = params.slug;

  useOnLanguageChange(() => {
    _eventBus.emit({
      eventName: evtTree.CMSOffers.Detail.Get,
      data: {
        slug,
      },
    });
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoadFinished(true);
    }, 2000);
    return () => {
      clearTimeout(timer);

      _eventBus.emit({
        eventName: "FLOW_CLOSE",
        data: "OfferDetailFlow",
      });
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      mainAppStartupFlowExecute("OfferDetailFlow");
    }, 100);
    if (slug) {
      const timer = setTimeout(() => {
        _eventBus.emit({
          eventName: evtTree.CMSOffers.Detail.Get,
          data: {
            slug,
          },
        });
      }, 400);
      return () => clearTimeout(timer);
    }
  }, [slug]);

  const offerDetail = useMemo(() => {
    if (!specialOfferDetail || specialOfferDetail.data.length === 0) return null;

    return specialOfferDetail.data[0];
  }, [specialOfferDetail]);

  const onBackClick = () => {
    _eventBus.emit({
      eventName: evtTree.CMSOffers.Detail.Back,
    });
  };

  return (
    <div>
      {!offerDetail ? (
        initialLoadFinished ? (
          <div className="text-center p-12">
            {intl.formatMessage({ id: "noData" })}
          </div>
        ) : null
      ) : (
        <Template4
          title={offerDetail.title}
          image={cmsImageUrl(offerDetail.full, offerDetail.image)}
          subtitle=""
          content={offerDetail.content}
          onBackClick={onBackClick}
        />
      )}

      <Section type="trust_builder offers_trust_builder">
        <div className="container">
          <Download />
        </div>
      </Section>
    </div>
  );
};

export default OfferDetailPage;
